module.exports = __webpack_public_path__ + "resources/images/NoCheck-b5854798a518057e0b5e9ac2f97b3387-cache.png";